"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ObjectIdentifier_1 = require("./_ObjectIdentifier");
exports._ObjectIdentifierList = {
    type: "list",
    flattened: true,
    member: {
        shape: _ObjectIdentifier_1._ObjectIdentifier
    }
};
//# sourceMappingURL=_ObjectIdentifierList.js.map